module.exports = __webpack_public_path__ + "img/img-3-13.7f373937.png";